import { MODULES_ABONNEMENT } from '../../../shared/business-logic/abonnement.ts';
import { useAbonnement } from '../hooks/useAbonnement.tsx';

/** Bandeau discret sous la navigation : mois gratuit en cours, modules verrouillés ou accès en tolérance hors ligne. */
export default function BandeauAbonnement({ onAbonnement }: { onAbonnement: () => void }) {
  const { acces, abonnement } = useAbonnement();
  let texte: string | null = null;
  let niveau = 'info';
  if (acces.inconnu) return null;
  if (acces.gratuit && acces.joursGratuitsRestants !== null) {
    const j = acces.joursGratuitsRestants;
    texte = `🎁 Mois gratuit : accès complet à tous les modules${abonnement?.gratuit_jusqu_au ? ` jusqu'au ${abonnement.gratuit_jusqu_au.split('-').reverse().join('/')}` : ''} (${j === 0 ? "dernier jour" : `${j} jour${j > 1 ? 's' : ''} restant${j > 1 ? 's' : ''}`}).`;
  } else if (acces.enTolerance) {
    texte = "⏳ Abonnement à renouveler : l'accès est maintenu quelques jours hors connexion. Reconnectez-vous pour vérifier.";
    niveau = 'warn';
  } else if (MODULES_ABONNEMENT.some((m) => !acces.modules[m])) {
    texte = '🔒 Certains modules sont verrouillés. Choisissez un pack pour les débloquer.';
    niveau = 'warn';
  }
  if (!texte) return null;
  return (
    <button type="button" className={`bandeau-abo ${niveau}`} onClick={onAbonnement}>
      {texte} <u>Voir les abonnements</u>
    </button>
  );
}
